var Reflux  = require('reflux'),
    request = require('superagent');

var ExperiencesActions = require('advocate/challenges/actions/experiences_actions');

var ExperiencesCollection = Reflux.createStore({
  listenables: ExperiencesActions,

  init: function(){
    this.data = {
      experiences : [],
      errors : null,
      hideCounters: false
    };
  },

  mapExperienceCounters :  function(){
    const { experiences, experience_counters } = this.data

    this.data.experiences = _.map(experiences, function(experience) {
      return _.extend(experience, _.find(experience_counters, { experience_id: experience.id }))
    });
  },

  fetchExperienceCounters : function(){
    request.get('/challenges/experience_counters')
      .set('Accept', 'application/json')
      .set('X-Requested-With', 'XMLHttpRequest')
      .end((errors, response) => {
          if(response.ok){
            this.data.experience_counters = response.body.data;
            this.data.errors = null;
            this.mapExperienceCounters();
          } else {
            this.data.experience_counters = [];
            this.data.errors = errors;
          }
          this.trigger(this.data);
        }
      );
  },

  onFetchExperiences : function(){
    request.get('/experiences')
      .set('Accept', 'application/json')
      .set('X-Requested-With', 'XMLHttpRequest')
      .end((errors, response) => {
          if(response.ok){
            this.data.experiences = response.body;
            this.data.errors = null;
            this.fetchExperienceCounters();
          } else {
            this.data.experiences = [];
            this.data.errors = errors;
          }
        }
      );
  },

  onShowExperience: function(experienceId) {
    window.location = `/experiences/${experienceId}`;
  }
});

module.exports = ExperiencesCollection;



// WEBPACK FOOTER //
// ./src/advocate/challenges/stores/experiences_collection.js